import React, { Component } from 'react'
import Link from '../utils/link'

class Slogan extends Component {

  render() {

    let { title, content } = this.props

    if(!title && !content) {
        return false
    }

    return (
      <section className='slogan'>

        <div className='slogan__inner'>

          <div className='slogan__content'>

            { title &&
              <div className='slogan__heading' >
                 <h3>{ title }</h3>
              </div>
            }

            { content && 
              <div className='slogan__text' dangerouslySetInnerHTML={{ __html: content }} />
            }
        
          </div>

        </div>

      </section>
    )
  }
}

export default Slogan
